﻿import * as React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            color: '#fff',
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark
            },
            borderRadius: 0
        },
    }));

interface IProps extends ButtonProps {
    component?: any;
    target?: string;
    notextwrap?: boolean;
    download?: boolean;
}

const defaultProps: IProps = {
    component: undefined,
    notextwrap: false,
    target: '_self',
    download: false,
}

function LightBlueButton(props: IProps) {
    const classes = useStyles();
    const { component, notextwrap, ...rest } = props;

    return (
        <React.Fragment>
            {component ?
                <Button {...rest} target="" className={classes.root} style={notextwrap ? { whiteSpace: 'nowrap' } : {}} component={component} />
                :
                <Button {...rest} className={classes.root} style={notextwrap ? { whiteSpace: 'nowrap' } : {}} />
            }
        </React.Fragment>
    );
}

LightBlueButton.defaultProps = defaultProps;
export default LightBlueButton;